import routes from '@/config/routes';
import { v3Get, v3Post } from './axios.instance.V3';

import type {
  ApiResponse,
  IUserCredentialsRequest,
  IUserIdentificationRequest,
  IUserChangePasswordRequest,
  IUserChangeShippingAddressRequest,
  IUserNotifyRequest,
  IUserNotifyTestPhoneNumberRequest,
} from './types';
import { ICodeRequest, IHelpRequest, IMobileRequest } from './types';

const prefix = '/agent/profile';
const url = {
  profile: `/pub/lxuser`,
  profileShipping: `${prefix}/shipping`,
  getCredentials: `${prefix}/credentials`,
  setCredentials: `${prefix}/credentials`,
  setIdentification: `${prefix}/set/identification`,
  setAddress: `${prefix}/set/address`,
  setNotify: `${prefix}/set/notify`,
  setPassword: `${prefix}/set/password`,
  testNotifySMS: `${prefix}/notification/test/sms`,
  mobilePhoneVerification: `/sms/sendverificationcode`,
  resendPhoneVerification: `/sms/resendverificationcode`,
  checkVerificationCode: `/sms/checkverificationcode`,
  sendContactServiceDesk: `/sms/contactservicedesk`,
  testNotifyVoice: `${prefix}/notification/test/voice`,
  getDeclinedApplications: 'pub/userProfile/validateaddress',
} as const;

const getUserProfile = (): ApiResponse => v3Get(url.profile);
const getUserProfileShippings = (): ApiResponse => v3Get(url.profileShipping);
const getUserProfileCredentials = (): ApiResponse => v3Get(url.getCredentials);
const getTimeZoneNames = (): ApiResponse => v3Get(routes.backendUrl.getTimeZoneNames);
const setUserProfileCredentials = (payload: IUserCredentialsRequest): ApiResponse =>
  v3Post(url.setCredentials, payload);
const setUserProfileIdentification = (payload: IUserIdentificationRequest): ApiResponse =>
  v3Post(url.setIdentification, payload);
const setUserProfileShippingAddress = (payload: IUserChangeShippingAddressRequest): ApiResponse =>
  v3Post(url.setAddress, payload);
const setUserProfileNotify = (payload: IUserNotifyRequest): ApiResponse => v3Post(url.setNotify, payload);
const setUserProfilePassword = (payload: IUserChangePasswordRequest): ApiResponse => v3Post(url.setPassword, payload);
const testNotifySms = (payload: IUserNotifyTestPhoneNumberRequest): ApiResponse => v3Post(url.testNotifySMS, payload);
const checkCodeVerification = (payload: ICodeRequest): ApiResponse => v3Post(url.testNotifySMS, payload);
const mobilePhoneVerification = (payload: IMobileRequest): ApiResponse =>
  v3Get(
    `${url.mobilePhoneVerification}?userId=${payload.userId}&mobile=${payload.mobile}&verificationType=${payload.verificationType}`,
  );
const resendPhoneVerification = (payload: IMobileRequest): ApiResponse =>
  v3Get(
    `${url.resendPhoneVerification}?userId=${payload.userId}&mobile=${payload.mobile}&verificationType=${payload.verificationType}`,
  );
const checkVerificationCode = (payload: ICodeRequest): ApiResponse =>
  v3Get(`${url.checkVerificationCode}?userId=${payload.userId}&mobile=${payload.mobile}&code=${payload.code}`);
const sendContactServiceDesk = (payload: IHelpRequest): ApiResponse => v3Post(url.sendContactServiceDesk, payload);
const testNotifyVoice = (payload: IUserNotifyTestPhoneNumberRequest): ApiResponse =>
  v3Post(url.testNotifyVoice, payload);
const getUserDeclinedApplicationsList = (userId: number): ApiResponse =>
  v3Get(`${url.getDeclinedApplications}?userId=${userId}`);
const canShowReferralMenu = (): ApiResponse => v3Get(`${routes.backendUrl.referralProgram.canShowReferralMenu}`);

export const apiUser = {
  getUserProfile,
  getUserProfileShippings,
  getUserProfileCredentials,
  setUserProfileCredentials,
  setUserProfileIdentification,
  setUserProfileShippingAddress,
  setUserProfileNotify,
  setUserProfilePassword,
  testNotifySms,
  mobilePhoneVerification,
  checkVerificationCode,
  checkCodeVerification,
  sendContactServiceDesk,
  resendPhoneVerification,
  testNotifyVoice,
  getTimeZoneNames,
  getUserDeclinedApplicationsList,
  canShowReferralMenu,
};
